import { render, staticRenderFns } from "./OperaMemberWindow.vue?vue&type=template&id=638ba7c1&"
import script from "./OperaMemberWindow.vue?vue&type=script&lang=js&"
export * from "./OperaMemberWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports